module.exports = __webpack_public_path__ + "static/img/topbar-all.11d67c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topbar-all.png
// module id = 6qjx
// module chunks = 0